import { type FC, useMemo } from 'react'
import { EmailCanvas, EmailPreviewCard } from './EmailPreviewCard'
import { renderPreview, sampleSenderName, samplesFor } from './preview/renderPreview'
import { parseLexicalEmailTemplate } from './validate/recordChecks'
import { emailOf } from './validate/validateState'

export interface StoredEmailPreviewProps {
  template: unknown
  values?: Record<string, string>
  className?: string
  frameClassName?: string
}

const previewOf = (template: unknown, values?: Record<string, string>): { fromName: string; subject: string; body: string } | null => {
  try {
    const parsed = parseLexicalEmailTemplate(template)
    if (parsed.kind !== 'email') {
      return null
    }
    const variables = emailOf(parsed.record.editor.state)?.variables ?? []
    const samples = values ?? samplesFor(variables)
    const rendered = renderPreview(
      parsed.record,
      samples,
      variables.map((variable) => variable.name),
    )
    return rendered.error === null ? { fromName: sampleSenderName(samples), subject: rendered.subject, body: rendered.body } : null
  } catch {
    return null
  }
}

export const StoredEmailPreview: FC<StoredEmailPreviewProps> = ({ template, values, className, frameClassName }) => {
  const preview = useMemo(() => previewOf(template, values), [template, values])
  return preview ? (
    <EmailPreviewCard fromName={preview.fromName} subject={preview.subject} body={preview.body} className={className} frameClassName={frameClassName} />
  ) : (
    <EmailCanvas className={className}>
      <p role='status' className='m-0 py-5 text-center paragraph-medium fw-normal zocks-text-gray-600'>
        Preview isn&apos;t available for this template.
      </p>
    </EmailCanvas>
  )
}
